import { LogIn } from 'lucide-react';
import { PORTAL_SESSION_EXPIRED_MESSAGE } from '../../services/apiConfig';
import ModalBackdrop from './ModalBackdrop';

function SessionExpiredModal({ isOpen, onRelogin }) {
  if (!isOpen) {
    return null;
  }

  return (
    <ModalBackdrop
      backdropClassName="bg-[rgba(33,27,22,0.24)] backdrop-blur-[3px]"
      contentClassName="items-center"
      zIndexClassName="z-[80]"
    >
      <div className="w-full max-w-md rounded-[24px] border border-[var(--theme-border-soft)] bg-white p-6 shadow-[0_24px_70px_rgba(var(--theme-shadow-rgb),0.2)]">
        <div className="flex items-start gap-4">
          <span className="grid h-12 w-12 shrink-0 place-items-center rounded-[16px] bg-[var(--theme-accent-soft)] text-[var(--theme-accent)]">
            <LogIn className="h-5 w-5" aria-hidden="true" />
          </span>
          <div className="min-w-0 flex-1">
            <h3 className="m-0 text-[1.08rem] font-semibold tracking-[-0.03em] text-[var(--theme-text)]">
              Session expired
            </h3>
            <p className="m-0 mt-2 text-[0.94rem] leading-6 text-[var(--theme-text-muted)]">
              {PORTAL_SESSION_EXPIRED_MESSAGE}
            </p>
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            className="rounded-full bg-[var(--theme-accent)] px-5 py-2.5 text-[0.9rem] font-semibold text-white shadow-[0_10px_22px_rgba(var(--theme-shadow-rgb),0.16)] transition hover:bg-[var(--theme-accent-strong)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--theme-focus)] focus-visible:ring-offset-2"
            type="button"
            onClick={onRelogin}
          >
            Relogin
          </button>
        </div>
      </div>
    </ModalBackdrop>
  );
}

export default SessionExpiredModal;
